import { render, staticRenderFns } from "./MapelList.vue?vue&type=template&id=39456b7e&scoped=true"
import script from "./MapelList.vue?vue&type=script&lang=js"
export * from "./MapelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39456b7e",
  null
  
)

export default component.exports